import { FormikErrors, FormikProps, withFormik } from 'formik'
import { t } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from '@lib/formik'

import { Body1 } from '@ui/Typography'
import { PopoverInput } from '@ui/components/Popover'

import { FormSubmitValues } from '@utils/formValidation'

import { ClientAreaLanguageDto } from '@model/ClientAreaLanguageDto'

import { Box } from '@shared/components/Box'

export interface CommunicationLanguageFormValues {
  communicationLanguageId: string
}

const CommunicationLanguageFormUI: React.FC<
  FormikProps<CommunicationLanguageFormValues> & OuterProps
> = (props) => {
  const { languages, values, setValues, handleSubmit, setSubmitting } = props
  const { t } = useTranslation()

  const handleChangeLanguage = (data?: ClientAreaLanguageDto) => {
    if (!data) return
    setSubmitting(true)
    setValues({ communicationLanguageId: data.id })
    handleSubmit()
  }

  return (
    <Box flex gap='x24' direction='column'>
      <Body1>{t('Profile.Choose the main language to communicate with support')}</Body1>
      <Form>
        <div className='field'>
          <div className='control'>
            <PopoverInput
              value={values.communicationLanguageId}
              onChange={handleChangeLanguage}
              options={languages}
              label={t('Communication language')}
            />
          </div>
        </div>
      </Form>
    </Box>
  )
}

interface OuterProps {
  communicationLanguageId?: string
  languages: ClientAreaLanguageDto[]
  onSubmit(values: FormSubmitValues<CommunicationLanguageFormValues>): Promise<void>
}

export const CommunicationLanguageForm = withFormik<OuterProps, CommunicationLanguageFormValues>({
  mapPropsToValues: ({ communicationLanguageId }) => {
    return {
      communicationLanguageId: communicationLanguageId || '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<CommunicationLanguageFormValues> = {}
    if (!values.communicationLanguageId) {
      errors.communicationLanguageId = t('Validation.Required')
    }
    return errors
  },
  enableReinitialize: true,
})(CommunicationLanguageFormUI)
